import t from "styled-components";
import { Text as n } from "./atoms-v243.js";
import { Button as p } from "./atoms-v26.js";
import { breakpoints as r } from "./atoms-v2125.js";
const l = t.div`
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.background`)};
  border-top: 1px solid ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.light`)};
  box-shadow: 0 -6px 4px 0 rgba(33 37 41 / 0.06);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 24px 12px;
  width: 100%;

  @media ${r.small} {
    gap: 8px;
    padding: 14px 16px 12px;
  }
`, x = t.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media ${r.medium} {
    flex-direction: row;
    gap: 16px;
    height: 44px;
  }

  @media ${r.large} {
    gap: 40px;
  }
`, g = t(n)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.tertiary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.xs-productive").toJS()};
  text-align: ${({ $isFloatingFooter: o }) => o ? "right" : "center"};

  a {
    color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.text.light.tertiary")};
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.xs-productive").toJS()};
  }
`, f = t.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > a {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
  }

  @media ${r.small} {
    flex-direction: row;

    > a {
      ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};
    }
  }
`, $ = t.div`
  display: flex;
  flex: 1;
  gap: 6px;
  justify-content: space-between;

  > button {
    flex: 1;
    flex-shrink: 1;
    min-width: 0;
  }
`, u = t(p)`
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
`, y = t(n)`
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};

  @media ${r.small} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
  }
`, k = t.div`
  align-items: center;
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.background`)};
  border-top: 1px solid ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.light`)};
  box-shadow: 0 -6px 4px 0 rgba(33 37 41 / 0.06);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  padding: 16px 40px;
  width: 100%;
`, b = t.div`
  align-items: center;
  display: flex;
  gap: 40px;
  grid-column: 2;
  justify-self: center;
`, v = t.div`
  grid-column: 3;
  justify-self: end;
  min-width: 0;
  text-align: right;
`, e = t.div`
  display: flex;
  flex-direction: column;
`, w = t.div`
  display: flex;
  gap: 12px;
`, S = t(n)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
`, J = t(n)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.02").toJS()};
`, F = t.div`
  display: flex;
  gap: 6px;

  > button {
    width: ${({ $isAloneButton: o }) => o ? "480px" : "237px"};
  }
`;
export {
  b as Center,
  k as FloatingFooterWrapper,
  u as FooterButton,
  g as FooterText,
  f as LeftSection,
  F as PaymentButtonWrapper,
  w as PriceInfoBottom,
  e as PriceInfoWrapper,
  y as PriceText,
  J as PriceTextFloatingFooter,
  v as Right,
  $ as RightSection,
  S as RoomName,
  x as UpperSection,
  l as Wrapper
};
